import { Box } from '@mui/material';

import { routesApp } from 'shared/config';
import { NavTabs } from 'shared/ui';

const NAV_TABS = [
  { name: 'Vaccines', path: routesApp.petsVaccines },
  { name: 'Diseases', path: routesApp.petsDiseases },
  { name: 'Countries', path: routesApp.petsCountries },
  { name: 'Breeds', path: routesApp.petsBreeds },
  { name: 'Post-vaccination reactions', path: routesApp.petsReactions },
];

export const Pets = () => {
  return (
    <Box display="flex" flexDirection="column" flex={1} px={3}>
      <NavTabs tabs={NAV_TABS} />
    </Box>
  );
};
